import { render, staticRenderFns } from "./herdes.vue?vue&type=template&id=1e0b21ce&scoped=true&"
import script from "./herdes.vue?vue&type=script&lang=js&"
export * from "./herdes.vue?vue&type=script&lang=js&"
import style0 from "./herdes.vue?vue&type=style&index=0&id=1e0b21ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0b21ce",
  null
  
)

export default component.exports